import { Link } from "react-router-dom";
import {
  Shield, Car, Building2, PartyPopper, Home as HomeIcon,
  HardHat, ParkingCircle, Siren, ClipboardCheck, MoonStar, ChevronRight
} from "lucide-react";

const SERVICES = [
  { icon: Shield, title: "Professional Security Officers", desc: "Uniformed, licensed officers stationed on-site to protect employees, guests, and property with visible deterrence." },
  { icon: Car, title: "Mobile Security Patrol", desc: "Marked patrol vehicles covering multiple sites on a schedule you set — a strong, visible deterrent." },
  { icon: MoonStar, title: "Day & Night Patrol", desc: "24/7 coverage tailored to your business hours, with detailed patrol logs and incident reporting." },
  { icon: PartyPopper, title: "Event Security", desc: "Private events, weddings, corporate gatherings, and public events — crowd control and access management." },
  { icon: Building2, title: "Commercial Property Security", desc: "Retail centers, office towers, and industrial facilities — comprehensive protection plans." },
  { icon: HomeIcon, title: "Residential Security", desc: "Neighborhoods, communities, HOAs, and private residences — peace of mind where you live." },
  { icon: HardHat, title: "Construction Site Security", desc: "Prevent theft, vandalism, trespassing, and equipment loss with dedicated overnight coverage." },
  { icon: ParkingCircle, title: "Parking Lot Patrol", desc: "Maintain order and deter incidents in parking structures and lots — day or night." },
  { icon: Siren, title: "Emergency Security Coverage", desc: "Rapid-response security when unexpected situations demand immediate professional support." },
  { icon: ClipboardCheck, title: "Custom Security Plans", desc: "Every property is different. We tailor a plan around your schedule, budget, and threat profile." },
];

export default function Services() {
  return (
    <div className="bg-[#000000] text-white">
      <section className="py-24 md:py-32 border-b border-white/8 relative">
        <div className="absolute inset-0 grid-lines-navy opacity-40" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-condensed text-xs font-bold tracking-[0.28em] uppercase text-red-500 mb-3">— Our Services</p>
          <h1 className="font-display font-black text-4xl md:text-6xl uppercase leading-[1] text-balance max-w-3xl">
            Comprehensive Security,<br />Engineered for Your Site<span className="text-red-500">.</span>
          </h1>
          <p className="mt-6 text-lg text-slate-400 leading-relaxed max-w-3xl">
            Explore the full range of professional security services we deliver across Washington State — from
            static officers to mobile patrol and emergency response.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {SERVICES.map((s, i) => (
              <div
                key={s.title}
                data-testid={`services-card-${i}`}
                className="group relative bg-[#141414]/60 border border-white/10 rounded-sm p-8 hover:border-red-500/50 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="absolute top-0 left-0 h-0.5 w-0 bg-red-600 group-hover:w-full transition-all duration-500" />
                <div className="w-12 h-12 rounded-sm bg-white/5 border border-white/10 flex items-center justify-center mb-5 group-hover:bg-red-600 group-hover:border-red-600 transition-colors">
                  <s.icon className="w-5 h-5 text-white" />
                </div>
                <h3 className="font-condensed font-bold uppercase text-white tracking-wider text-lg">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center">
            <Link
              to="/quote"
              data-testid="services-cta-quote"
              className="inline-flex items-center gap-2 bg-white hover:bg-slate-100 text-[#0A0A0A] px-7 py-3.5 rounded-sm font-condensed uppercase tracking-wider font-bold transition-colors"
            >
              Request a Quote <ChevronRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
